export default "__VITE_ASSET__My8gmYjy__"